import {useContext} from 'react'
import {Menu, Icon, Dropdown, MenuItemProps, DropdownItemProps} from 'semantic-ui-react'
import {AuthContext, RequirePermission} from '@/features/auth'
import {LegacyCatalogContext} from '@/features/data-sources'
import {DarkModeToggle} from '@/features/dark-mode'
import {UploadStatusMenuItem} from '@/features/uploads'
import {useNavState} from '@/features/nav-state'
import logo from '@/logo.png'
import logoDark from '@/logo-dark.png'
import './style.css'
// eslint-disable-next-line no-restricted-imports
import {CatalogSelector} from '@/features/data-sources/components/catalog-selector'

export interface IMenuLinkItemProps extends MenuItemProps {
  to: string
  clearParams?: boolean
}

export interface IDropdownLinkItemProps extends DropdownItemProps {
  to: string
  clearParams?: boolean
}

function LinkMenuItem(props: IMenuLinkItemProps) {
  const {to, clearParams, onClick, ...rest} = props

  const {navigate} = useNavState()

  function handleOnClick(
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    data: MenuItemProps
  ) {
    if (onClick) {
      onClick(event, data)
      return
    }
    navigate({
      path: to,
      clearState: clearParams,
    })
  }

  return (
    <Menu.Item
      onClick={handleOnClick}
      {...rest}
    />
  )
}

function LinkDropdownItem(props: IDropdownLinkItemProps) {
  const {to, clearParams, onClick, ...rest} = props

  const {navigate} = useNavState()

  function handleOnClick(
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    data: DropdownItemProps
  ) {
    if (onClick) {
      onClick(event, data)
      return
    }
    navigate({
      path: to,
      clearState: clearParams,
    })
  }

  return (
    <Dropdown.Item
      onClick={handleOnClick}
      {...rest}
    />
  )
}

export function MainMenu() {
  const {user, signOut} = useContext(AuthContext)

  const {
    showCatalogOverrideDialog,
    // preferences,
    // setPreferences,
  } = useContext(LegacyCatalogContext)

  return (
    <Menu className='main-menu'>
      <LinkMenuItem
        to='/'
        className='logo'
        clearParams
      >
        <div
          className='logo light'
          style={{
            backgroundImage: `url(${logo})`,
          }}
        />
        <div
          className='logo dark'
          style={{
            backgroundImage: `url(${logoDark})`,
          }}
        />
      </LinkMenuItem>

      <LinkMenuItem
        to='/'
        clearParams
      >
        <Icon name='home' />
        Home
      </LinkMenuItem>

      <RequirePermission require='report.customer_dashboard'>
        <LinkMenuItem
          to='/dashboard'
          clearParams
        >
          <Icon name='tachometer alternate' />
          Dashboard
        </LinkMenuItem>
      </RequirePermission>

      <LinkMenuItem
        to='/library'
        clearParams
      >
        <div>
          <Icon name='list' />
          Library
        </div>
      </LinkMenuItem>

      {/* <LinkMenuItem to='/vionverse' clearParams>
            <Icon name='star' />
            Vionverse
        </LinkMenuItem> */}

      <RequirePermission require={'label.video_lab_access'}>
        <LinkMenuItem to='/videolab'>
          <Icon name='video' />
          Video lab
        </LinkMenuItem>
      </RequirePermission>

      <RequirePermission require={'auth_utils.access_to_compare_tool'}>
        <LinkMenuItem to='/compare'>
          <Icon name='list' />
          Compare
        </LinkMenuItem>
      </RequirePermission>

      <RequirePermission require={'user.user_admin'}>
        <LinkMenuItem
          to='/users'
          clearParams
        >
          <Icon name='user' />
          Users
        </LinkMenuItem>
      </RequirePermission>

      <RequirePermission
        require={'label.can_view_legacy_tools'}
        isPresent={false}
      >
        <RequirePermission require={'api_key.fingerprint_plus_api'}>
          <LinkMenuItem
            to='/api-viewers'
            clearParams
          >
            <Icon name='cloud download' />
            Results API viewer
          </LinkMenuItem>
        </RequirePermission>
      </RequirePermission>
      <RequirePermission require={'label.can_view_legacy_tools'}>
        <Dropdown
          item
          simple
          icon='lab'
          text='Tools'
        >
          <Dropdown.Menu>
            <LinkMenuItem to='/browse'>
              <Icon name='list' />
              Mixer
            </LinkMenuItem>
            <LinkDropdownItem
              to='/api-viewers'
              clearParams
            >
              <Icon name='cloud download' />
              Results API viewer
            </LinkDropdownItem>
            {/* <LinkDropdownItem
              to='/montage'
              clearParams
            >
              <Icon name='film' />
              Montage editor
            </LinkDropdownItem> */}
            <LinkDropdownItem
              to='/expressions'
              clearParams
            >
              <Icon name='terminal' />
              Expressions
            </LinkDropdownItem>
            <LinkDropdownItem
              to='/plots'
              clearParams
            >
              <Icon name='chart line' />
              Plotly lab
            </LinkDropdownItem>
          </Dropdown.Menu>
        </Dropdown>
      </RequirePermission>

      <Menu.Menu position='right'>
        <UploadStatusMenuItem />
        <CatalogSelector
          item
          className='catalog-selector-wrap'
        />
        <Dropdown
          item
          simple
          icon='user'
        >
          <Dropdown.Menu>
            <RequirePermission require={'auth_utils.access_to_all_catalogs'}>
              <Dropdown.Item
                className='red'
                icon='cog'
                text='Catalog overrides'
                onClick={() => showCatalogOverrideDialog()}
              />
            </RequirePermission>
            <Dropdown.Item content={<DarkModeToggle />} />
            <Dropdown.Item
              text={`Sign out ${user.username}`}
              icon='sign out'
              onClick={signOut}
            />
          </Dropdown.Menu>
        </Dropdown>
      </Menu.Menu>
    </Menu>
  )
}
